<template>
  <el-dropdown size="small" split-button type="info" style="float: right;">
    Histórico de cotações
    <el-dropdown-menu slot="dropdown">
    <el-dropdown-item style="width: 350px">
      <span style="color: #8492a6; font-size: 13px">20/10/2023 16:15</span>
      <span> - 89204420 <i class="fa fa-arrow-right" aria-hidden="true"></i>89217360</span>
    </el-dropdown-item>
    <el-dropdown-item style="width: 350px">
      <span style="color: #8492a6; font-size: 13px">20/10/2023 16:15</span>
      <span> - Planilha (12 linhas)</span>
    </el-dropdown-item>
    <el-dropdown-item style="width: 350px">
      <span style="color: #8492a6; font-size: 13px">20/10/2023 16:15</span>
      <span> - 89204420 <i class="fa fa-arrow-right" aria-hidden="true"></i>89217360</span>
    </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>      
</template>

<script>
export default {
  name: 'CalculateHistory',
  methods: {
    submitForm() {

    }
  }
}
</script>